import { takeEvery, call, put } from "redux-saga/effects";
import {
  TRIGGER_DIAGRAMS_INTERPRET_REQUEST,
  TRIGGER_DIAGRAMS_INTERPRET_SUCCESS,
  TRIGGER_DIAGRAMS_INTERPRET_FAILURE,
  TRIGGER_DIAGRAMS_RENDER_REQUEST,
  TRIGGER_DIAGRAMS_RENDER_SUCCESS,
  TRIGGER_DIAGRAMS_RENDER_FAILURE,
} from "../actions/diagramsAgentActions";
import {
  triggerDiagramsInterpretApi,
  triggerDiagramsRenderApi,
  triggerFlowchartApi,
  triggerChartApi,
} from "../apis/diagramsAgentApi";

// One submit action covers all "kick off a run" flows. The component sets
// payload.diagramType so the saga can route to the right BE entrypoint —
// architecture goes through the two-phase interpret/render path; flowchart
// and chart go through single-shot pipelines that produce one artifact.
const API_BY_TYPE = {
  flowchart: triggerFlowchartApi,
  chart: triggerChartApi,
};

function* triggerInterpret(action) {
  try {
    const apiFn = API_BY_TYPE[action.payload?.diagramType] || triggerDiagramsInterpretApi;
    const result = yield call(apiFn, action.payload);
    yield put({ type: TRIGGER_DIAGRAMS_INTERPRET_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_DIAGRAMS_INTERPRET_FAILURE, error: error.message });
  }
}

function* triggerRender(action) {
  try {
    const result = yield call(triggerDiagramsRenderApi, action.payload);
    yield put({ type: TRIGGER_DIAGRAMS_RENDER_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_DIAGRAMS_RENDER_FAILURE, error: error.message });
  }
}

export default function* diagramsAgentSaga() {
  yield takeEvery(TRIGGER_DIAGRAMS_INTERPRET_REQUEST, triggerInterpret);
  yield takeEvery(TRIGGER_DIAGRAMS_RENDER_REQUEST, triggerRender);
}
